import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.jsx";
import AppErrorBoundary from "./AppErrorBoundary";
import "./index.css";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "./sentry.js";
import "./stale-chunk-handler";
import "./shared/services/diagnostic/appLifecycleRecorder";
import { handleGlobalFlussonicError, handleGlobalFlussonicUnhandledRejection } from "./layout-components/squawk-player/FlussonicErrorTracker";

// if (import.meta.hot) {
//     import.meta.hot.accept();
// }

// Register global error handlers for Flussonic player errors
window.addEventListener("error", handleGlobalFlussonicError);
window.addEventListener("unhandledrejection", handleGlobalFlussonicUnhandledRejection);

// Set page title based on environment
const appEnv = import.meta.env.VITE_APP_ENV;
document.title = appEnv === "production" ? "Newsquawk" : "Newsquawk: Dev";

const queryClient = new QueryClient();

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <AppErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </AppErrorBoundary>
  </React.StrictMode>
);
